// @core/api/endpoints/platform/update_data_residency_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DataResidencyPolicyResponse,
  UpdateDataResidencyPolicyRequest,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Update data residency policy
 * Updates the platform's data residency policy. Changes affect all existing federation peers and may trigger re-validation of cross-border data flows.
 */
export async function UpdateDataResidencyPolicy(
  platform_id: string,
  data: UpdateDataResidencyPolicyRequest,
  options?: RequestOptions
): Promise<DataResidencyPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/data-residency`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.put<DataResidencyPolicyResponse>(requestPath, data, requestOptions);
}
